import I18n from 'I18n';
import { useCallback, useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { requestSeatUpgrade } from '../../../lib/requests';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { SeatSelector } from './SeatSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequestSeatModal = ({
  alertStore,
  apiName,
  setShowModal,
  showSeatSelector,
  trackingData,
  upgradeConfig
}) => {
  const [requestReason, setRequestReason] = useState();
  const [selectedSeatType, setSelectedSeatType] = useState();
  useEffect(() => {
    track('view-upgrade-admin-prompt', Object.assign({}, getTrackingProperties({
      apiName,
      trackingData,
      upgradeConfig,
      sourceKey: 'ADMIN_MODAL'
    }), {
      apiNames: [apiName],
      modalType: 'requestSeatUpgrade'
    }));
    // keep empty dependency array so that this event only fires once, not on every rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSendRequest = useCallback(() => {
    requestSeatUpgrade({
      apiName,
      requestReason: requestReason || 'User requested seat access',
      requestedSeatType: selectedSeatType !== null && selectedSeatType !== void 0 ? selectedSeatType : undefined
    }).then(() => {
      alertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestSeat.modal.onSuccessAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestSeat.modal.onSuccessAlert.title"
        }),
        type: 'success'
      });
    }).catch(() => {
      alertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestSeat.modal.onFailureAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestSeat.modal.onFailureAlert.title"
        }),
        type: 'danger'
      });
    }).finally(() => {
      setShowModal(false);
    });
  }, [alertStore, apiName, requestReason, selectedSeatType, setShowModal]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "default",
    width: 480,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "admin-modal-close-button",
        onClick: () => {
          setShowModal(false);
        }
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `purchaseMotions.requestSeat.modal.title`
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Text, {
        paddingInlineEnd: "400",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          marginBlockEnd: "400",
          children: [/*#__PURE__*/_jsx(Illustration, {
            name: "lock",
            height: 60,
            marginBlockEnd: "400"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.requestSeat.modal.body.title"
            })
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestSeat.modal.body.subtitle"
          })]
        }), showSeatSelector && /*#__PURE__*/_jsx(SeatSelector, {
          apiName: apiName,
          setSelectedSeatType: setSelectedSeatType
        }), /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestSeat.modal.reasonInput.header"
          }),
          children: /*#__PURE__*/_jsx(TextArea, {
            value: requestReason,
            onChange: event => {
              setRequestReason(event.target.value);
            },
            placeholder: I18n.text('purchaseMotions.requestSeat.modal.reasonInput.placeholder')
          })
        }), /*#__PURE__*/_jsx(_Fragment, {})]
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "admin-modal-submit-button",
        use: "primary",
        onClick: handleSendRequest,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `purchaseMotions.requestSeat.modal.submitButton`
        })
      })
    })]
  });
};